<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 200.963"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M57.238 102.433c-3.314,0.622 -6.648,0.829 -10.001,0.624 -4.647,21.062 -3.447,48.006 0.769,80.121 2.793,-25.806 1.741,-50.057 9.232,-80.745z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M34.48 70.681c4.838,11.201 11.762,18.63 18.538,18.018 5.717,-0.515 8.635,-4.08 11.754,-8.599 1.85,-2.679 3.563,-5.855 5.045,-9.647 -6.621,-4.422 -12.582,-6.917 -17.884,-7.484 -2.251,-0.241 -4.384,-0.135 -6.397,0.319 -4.204,0.949 -7.89,3.413 -11.056,7.393z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M51.933 62.969c5.302,0.567 11.263,3.062 17.884,7.484 1.967,-5.029 3.528,-11.14 4.465,-18.608 0.36,-2.868 0.692,-6.594 0.928,-10.621 -6.407,-2.128 -13.118,-2.335 -20.132,-0.623 -0.911,8.063 -1.96,15.519 -3.145,22.368z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M55.078 40.601c7.014,-1.712 13.725,-1.505 20.132,0.623 0.466,-7.95 0.558,-17.076 -0.254,-23.103 -1.273,-9.465 -6.521,-10.656 -17.113,-10.342 -0.712,11.875 -1.634,22.816 -2.765,32.822z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M45.536 63.288c-1.204,-3.513 -1.873,-10.784 -2.007,-21.811 -4.281,-1.707 -9.585,-1.642 -15.913,0.193 0.421,3.431 0.957,6.953 1.55,10.543 0.89,5.378 2.257,10.5 3.971,15.116 0.426,1.15 0.875,2.268 1.343,3.352 3.166,-3.98 6.852,-6.444 11.056,-7.393z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M27.616 41.67c6.328,-1.835 11.632,-1.9 15.913,-0.193 -0.106,-8.737 0.123,-19.832 0.688,-33.285 -6.367,-0.224 -13.598,-0.859 -15.213,3.816 -2.918,8.445 -2.75,18.581 -1.388,29.662z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M43.529 41.477c0.134,11.027 0.803,18.298 2.007,21.811 2.013,-0.454 4.146,-0.56 6.4,-0.319 1.183,-6.844 2.231,-14.303 3.142,-22.368 1.131,-10.006 2.053,-20.947 2.765,-32.822 -2.775,0.082 -5.917,0.267 -9.451,0.434 -1.293,0.061 -2.712,0.031 -4.175,-0.021 -0.565,13.453 -0.794,24.548 -0.688,33.285z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M29.166 52.213c-2.511,-15.185 -3.984,-29.145 -0.162,-40.205 1.986,-5.75 12.469,-3.468 19.388,-3.795 17.021,-0.804 24.957,-2.038 26.564,9.908 1.222,9.08 0.396,25.194 -0.674,33.724 -1.643,13.098 -5.207,22.022 -9.51,28.255 -3.119,4.519 -6.037,8.084 -11.754,8.599 -10.061,0.909 -20.448,-15.912 -23.852,-36.486zm3.971 15.116c0.395,30.215 0.546,63.88 5.292,104.519 3.19,27.317 11.145,33.317 16.156,14.522 3.455,-12.961 4.309,-31.304 4.24,-43.662 0.504,-23.571 3.842,-46.63 10.992,-72.255"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
